import React from "react";
import StatsCounter from "../Common/StatsCounter";
import ProjectsSection from "../Common/ProjectsSection";
import { statsData } from "../../data/statsData";


function Project() {

  const projects = [
    {
      id: 1,
      image: "https://themewagon.github.io/HighTechIT/img/project-1.jpg",
      title: "Web design",
      subtitle: "Web Analysis",
      delay: ".3s",
    },
    {
      id: 2,
      image: "https://themewagon.github.io/HighTechIT/img/project-2.jpg",
      title: "Cyber Security",
      subtitle: "Cyber Security Core",
      delay: ".5s",
    },
    {
      id: 3,
      image: "https://themewagon.github.io/HighTechIT/img/project-3.jpg",
      title: "Mobile Info",
      subtitle: "Upcomming Phone",
      delay: ".7s",
    },
    {
      id: 4,
      image: "https://themewagon.github.io/HighTechIT/img/project-4.jpg",
      title: "Web Development",
      subtitle: "Web Analysis",
      delay: ".3s",
    },
    {
      id: 5,
      image: "https://themewagon.github.io/HighTechIT/img/project-5.jpg",
      title: "Digital Marketing",
      subtitle: "Marketing Analysis",
      delay: ".5s",
    },
    {
      id: 6,
      image: "https://themewagon.github.io/HighTechIT/img/project-6.jpg",
      title: "Keyword Research",
      subtitle: "Keyword Analysis",
      delay: ".7s",
    },
  ];


  return (
<div className="project">

    <div class="container-fluid page-header py-5">
            <div class="container text-center py-5">
                <h1 class="display-2 text-white mb-4 animated slideInDown">Projects</h1>
                <nav aria-label="breadcrumb animated slideInDown">
                    <ol class="breadcrumb justify-content-center mb-0">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item"><a href="#">Pages</a></li>
                        <li class="breadcrumb-item" aria-current="page">Projects</li>
                    </ol>
                </nav>
            </div>
        </div>
        
        <StatsCounter stats={statsData} />
        <ProjectsSection />

     
</div>



 );
}

export default Project;  